import React from 'react';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';
import Img1 from '../assets/work2.png';
import Img2 from '../assets/work3.png';
import Img3 from '../assets/work1.png';
import Img4 from '../assets/work4.png';
import Img5 from '../assets/work5.png';
import Img6 from '../assets/work6.png';
import Img7 from '../assets/work7.png';
import Img8 from '../assets/work8.png';
import Img9 from '../assets/work9.png';
import Img10 from '../assets/work10.png';
import Img11 from '../assets/work11.png';

const Work = () => {
  const projects = [
    { img: Img4,title:'Water & Amusement Park Website' , text: 'Fun & Food Village', link: 'https://www.funnfoodparks.com/' },
    { img: Img10,title:'Language Website', text: 'Kalakrit', link: 'https://kalakrit.in/' },
    { img: Img5,title:'Plywood Website' , text: 'Globe Panel', link: 'https://brandbugleindia.in/globe-panel/' },
    { img: Img6,title:'Rubber Website' , text: 'Mayur Rubber', link: 'https://mayurrubbers.com/new/' },
    { img: Img7,title:'Architect Website' , text: 'Qbana Interior', link: 'https://brandbugleindia.in/qbana-interiors/' },
    { img: Img11,title:'Landing Page' , text: 'Guns For Pride', link: 'https://brandbugleindia.com/guns-for-pride/' },
    { img: Img9,title:'Yoga Website' , text: 'Home Yoga Classes', link: '#your_anchor_id' },
    { img: Img8,title:'Blog Webiste' , text: 'Copper Collab', link: '#your_anchor_id' },
    { img: Img2,title:'Ecommerce Webite' , text: 'Axma Clothes', link: '#your_anchor_id' },
    { img: Img3,title:'Portfolio Webiste' , text: 'Aabid Saifi', link: '#your_anchor_id' },
  ];

  return (
    <section className='section h-auto' id='work'>
      <div className='container mx-auto'>
        <div>
          <h2 className='h2 leading-tight text-accent'>My latest <br /> Work.</h2>
          <p className='max-w-l mb-5'>Welcome to my portfolio! Here, you can see the cool stuff I've made in web development. These projects show how much I love building websites that are easy to use. Let me show you some of the awesome things I've done:</p>
          <a href='#contact'><button className='btn btn-sm mb-10'>Contact Me</button></a>
        </div>
        <div className='grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-10'>
          {projects.map((project, index) => (
            <motion.div
              key={index}
              variants={fadeIn(index % 2 === 0 ? 'right' : 'left', index % 2 === 0 ? 0.3 : 0.2)}
              initial='hidden'
              whileInView={'show'}
              viewport={{ once: false, amount: 0.3 }}
              className={`flex flex-col gap-y-12 mb-0 lg:mb-0 `}>
              <a href={project.link} target='_blank'>
                <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
                  <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300 cursor-pointer'></div>
                  <img className='group-hover:scale-125 transition-all duration-500' src={project.img} alt='' />
                  <div className='-bottom-full absolute left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
                    <span className='text-gradient'>{project.title}</span>
                  </div>
                  <div className='-bottom-full absolute left-12 group-hover:bottom-14 transition-all duration-700 z-50'>
                    <span className='text-3xl text-white'>{project.text}</span>
                  </div>
                </div>
              </a>
            </motion.div> 
          ))}
        </div>
      </div>
    </section>
  );
};

export default Work;
